import React from "react";
import { QUALIFY } from "../../data";

export default function QualifyBar() {
  return (
    <div style={{ background: "#00030F", borderBottom: "1px solid var(--line)" }}>
      <div className="mx-auto max-w-[1080px] px-4 py-2 text-center">
        <span
          style={{
            fontFamily: "Montserrat, sans-serif",
            textTransform: "uppercase",
            letterSpacing: "0.16em",
            fontSize: "0.66rem",
            fontWeight: 700,
            color: "var(--muted)",
          }}
        >
          {QUALIFY}
        </span>
      </div>
    </div>
  );
}
